import React, { useEffect } from 'react';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const InfoPopup = ({
  title,
  subtitle,
  icon,
  closePopup,
  buttonText = 'Ok',
  confirmButtonText,
  closePopupSeconds,
  className = '',
}) => {
  const t = useTranslation();

  useEffect(() => {
    if (closePopupSeconds) {
      const intervalId = setTimeout(closePopup, closePopupSeconds * 1000);

      return () => clearInterval(intervalId);
    }
  }, [closePopupSeconds]);

  return (
    <div className={`info-popup popup-content popup-small ${className}`}>
      <h3 className="popup-title">{t(title)}</h3>
      {subtitle && <p className="popup-subtitle text-center">{Array.isArray(subtitle) ? t.jsx(...subtitle) : t(subtitle)}</p>}
      <div className="popup-main-content">
        {icon && <i className={`global-icon ${icon}`} />}
      </div>
      {!!buttonText && (
        <button type="button" onClick={closePopup} className="popup-cancel-button">
          {t(buttonText)}
        </button>
      )}
      {!!confirmButtonText && (
        <button type="button" onClick={closePopup} className="popup-confirm-button">
          {t(confirmButtonText)}
        </button>
      )}
    </div>
  );
};

export default InfoPopup;
